import { RootState } from './index';

export const authSelector = (state: RootState) => state.auth;
